import { Component } from 'react'
import { Link } from 'react-router-dom'
import editIcon from '../../../../images/edit_icon.svg'
import deleteIcon from '../../../../images/delete-element-icon.svg'
import Translation from '../../Translation/cont/Translation'
import TranslationTime from '../../Translation/cont/TranslationTime'
import TmdbExternalLink from '../../general/TmdbExternalLink'
import CinemaBadgeList from '../../general/CinemaBadgeList'
import DialogEditPreviewMovie from './DialogEditPreviewMovie'

class PreviewMoviesListItem extends Component {
    constructor(props) {
        super(props)
        this.state = { showConfirm: false, showEditDialog: false }
    }

    render() {
        const { item, startingDate, cinemas, allCinemaIds, movieMappings, tmdbMovies, index, onDelete, onEdit, onKsConnect } = this.props
        const { showConfirm, showEditDialog } = this.state
        const evenOdd = index % 2 === 0 ? 'odd' : 'even'

        const mapping = movieMappings && movieMappings[item.metaMoviePk]
        const tmdbMoviePk = mapping && mapping.tmdb
        const tmdbMovie = tmdbMoviePk && tmdbMovies && tmdbMovies[tmdbMoviePk]
        const tmdbId = tmdbMovie && tmdbMovie.tmdb_id
        const isTmdbLinked = !!tmdbMoviePk
        const ksLinked = !!(mapping && mapping.source && mapping.source.length > 0)
        const resolvedCinemaIds = item.visibleIn && item.visibleIn.length > 0 ? item.visibleIn : (allCinemaIds || [])
        
        return (
            <>
                <li className={`preview-movies-item ${evenOdd}`}>
                    <div className="pm-item-grid">
                        <div className="pm-item-icons">
                            <Link to={`/website/previewMovies/movie/${item.metaMoviePk}`}>
                                <img src={editIcon} alt="Bearbeiten" style={{ width: 17, height: 17, opacity: 0.7 }} />
                            </Link>
                            <button
                                onClick={() => this.setState({ showConfirm: true })}
                                style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, opacity: 0.6 }}
                            >
                                <img src={deleteIcon} alt="Löschen" style={{ width: 17, height: 17 }} />
                            </button>
                        </div>

                        <div>
                            <div className="pm-item-title text-small-light" style={{ cursor: 'pointer' }} onClick={() => this.setState({ showEditDialog: true })}>{item.title}</div>
                            <div className="tmdb-cinema-badges" style={{ cursor: 'pointer' }} onClick={() => this.setState({ showEditDialog: true })}>
                                <CinemaBadgeList
                                    resolvedCinemaIds={resolvedCinemaIds}
                                    allCinemaIds={allCinemaIds || []}
                                    cinemas={cinemas}
                                />
                            </div>
                        </div>

                        <div className={`text-small-light pm-item-date${startingDate || item.startDateDescription ? '' : ' pm-item-date--empty'}`}>
                            {startingDate ? (
                                <TranslationTime id="date" timeString={startingDate} />
                            ) : item.startDateDescription ? (
                                item.startDateDescription
                            ) : (
                                '—'
                            )}
                        </div>

                        <div className="pm-item-col">
                            {isTmdbLinked ? (
                                <>
                                    <div className="check-indicator has-content" />
                                    {tmdbId ? (
                                        <TmdbExternalLink tmdbId={tmdbId} className="tmdb-external-link text-small-light" />
                                    ) : (
                                        <span className="tmdb-external-link text-small-light">TMDB</span>
                                    )}
                                </>
                            ) : (
                                <>
                                    <div className="check-indicator has-no-content" />
                                    <Link to={`/tmdb/${item.metaMoviePk}?from=previewmovies`}>
                                        <button className="tmdb-link-btn text-small-regular"><Translation id="link_tmdb_button" /></button>
                                    </Link>
                                </>
                            )}
                        </div>

                        <div className="pm-item-col">
                            {ksLinked ? (
                                <>
                                    <div className="check-indicator has-content" />
                                    <span className="linked-label text-small-light"><Translation id="preview_movies_ks_linked" /></span>
                                </>
                            ) : (
                                <>
                                    <div className="check-indicator has-no-content" />
                                    <button className="tmdb-link-btn text-small-regular" onClick={() => onKsConnect(item.metaMoviePk)}><Translation id="preview_movies_ks_connect_button" /></button>
                                </>
                            )}
                        </div>
                    </div>
                </li>

                {showConfirm && (
                    <div className="preview-movie-dialog-overlay" onClick={() => this.setState({ showConfirm: false })}>
                        <div className="preview-movie-dialog" onClick={e => e.stopPropagation()}>
                            <div className="preview-movie-dialog-head">
                                <span className="preview-movie-dialog-title"><Translation id="preview_movies_delete_confirm_title" /></span>
                                <button className="preview-movie-dialog-close text-small-regular" type="button" onClick={() => this.setState({ showConfirm: false })}>✕</button>
                            </div>
                            <div className="preview-movie-dialog-body">
                                <span className="pm-delete-confirm-name">{item.title}</span>
                            </div>
                            <div className="preview-movie-dialog-footer">
                                <button className="button" onClick={() => { onDelete(item.pk); this.setState({ showConfirm: false }) }}>
                                    <Translation id="remove_button" />
                                </button>
                                <button className="button button--cancel" type="button" onClick={() => this.setState({ showConfirm: false })}>
                                    <Translation id="cancel_button" />
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {showEditDialog && (
                    <DialogEditPreviewMovie
                        item={item}
                        startingDate={startingDate}
                        cinemas={cinemas}
                        cliCinemasIdList={allCinemaIds || []}
                        onSave={(data) => { onEdit(item.pk, data); this.setState({ showEditDialog: false }) }}
                        onClose={() => this.setState({ showEditDialog: false })}
                    />
                )}
            </>
        )
    }
}

export default PreviewMoviesListItem
